var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M10 17a7 7 0 100-14 7 7 0 000 14z",
    stroke: "#8298A1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.413 12.013H9.52v-.463c0-.166.016-.315.048-.453a1.35 1.35 0 01.137-.363c.064-.111.132-.213.217-.314.085-.101.185-.202.291-.304l.355-.335a1.88 1.88 0 00.349-.394c.09-.144.137-.33.137-.554 0-.31-.095-.554-.29-.736-.196-.18-.445-.271-.752-.271-.317 0-.571.1-.762.309-.19.207-.301.453-.333.746L8 8.774c.038-.277.117-.522.239-.746.121-.224.27-.41.455-.56a2.06 2.06 0 01.624-.35c.233-.08.487-.118.751-.118.265 0 .519.037.746.117.228.08.44.192.614.341.18.15.317.336.418.56.1.218.154.474.154.761 0 .203-.022.384-.07.538a1.48 1.48 0 01-.184.416c-.08.122-.17.24-.286.351-.117.107-.238.219-.37.336a4.816 4.816 0 00-.323.293c-.09.09-.159.176-.212.267a.915.915 0 00-.111.298 2.166 2.166 0 00-.032.405v.33zm.238 1.353a.623.623 0 01-.18.442.608.608 0 01-.46.192.629.629 0 01-.455-.187.626.626 0 01.455-1.07.62.62 0 01.64.623z",
    fill: "#8298A1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.594faab87954ab50b2fd60335a0d1255.svg";
export { ForwardRef as ReactComponent };